import { useEffect, useState } from "react";
import { getSelectedFinancialYear } from "../../../../CommonFunction/GetUserInfo";
import { useAppVersionChecker } from "../../../Templets/Layout/CheckVersion";
import Button from "../../Button/Button";
import PortalFooter from "../../Reactportal/PortalFooter";
import Reactportal from "../../Reactportal/Reactportal";
import AddFinancialMaster from "../AddFinancialYear/AddFinancialYear";

const VersionCheck = () => {
  const [isLatest, setIsLatest] = useState(false);
  const [financialYear, setFinancialYear] = useState(true);

  const message = useAppVersionChecker(setIsLatest);

  useEffect(() => {
    const fetchFinancialYear = async () => {
      setTimeout(async () => {
        const FinancialYearData = await getSelectedFinancialYear();
        if (!FinancialYearData) {
          setFinancialYear(false);
        }
      }, 1500);
    };

    fetchFinancialYear();
  }, []);

  const footerContent = (
    <PortalFooter
      TypeOfPortal={"WARNING"}
      renderContent={() => (
        <>
          <Button
            name="modalbutton"
            text={"Refresh"}
            action={() => window.location.reload(true)}
            style={{ cursor: "pointer" }}
          ></Button>
        </>
      )}
    />
  );
  return (
    <>
      {isLatest && (
        <Reactportal FoooterContent={footerContent} open={true} showCloseIcon={false}>
          <div className="For_Latest_Version_Refresh">
            <h2>A new version is available.</h2>
            <p>{message}</p>
          </div>
        </Reactportal>
      )}
      {!isLatest && !financialYear && (
        <AddFinancialMaster
          TypeOfPortal={"Add"}
          show={true}
          ParentPortalCloseFunction={() => {}}
          isWholePageReload={true}
          showCloseIcon={false}
          showCancelButton={false}
        />
      )}
    </>
  );
};

export default VersionCheck;
